module.exports = __webpack_public_path__ + "static/media/atom.eda808c5.svg";